import flex from "@/utils/flex";
import styled, { css } from "styled-components";
import { desktop, mobile, tablet } from "@/utils/responsive";

export const Body = styled.div`
  ${flex({ direction: "column" })}
  height: 90vh;
  font-size: 3rem;
  div {
    margin: 1rem;
  }
  button {
    border: none;
    margin: 2rem;
    width: 200px;
    height: 100px;
    cursor: pointer;
    border-radius: 30px;
    :hover,
    :active {
      background-color: var(--sub);
    }
  }

  span {
    font-size: 2rem;
  }

  // responsive
  ${mobile(css`
    font-size: 1.4rem;
    button {
      width: 200px;
      height: 70px;
    }
    .buttonFlex {
      ${flex({ direction: "column" })}
    }
  `)}
  ${tablet(css`
    font-size: 2rem;
    button {
      width: 140px;
      height: 100px;
      margin: 1rem;
    }
    .buttonFlex {
      ${flex({})}
    }
  `)}
  ${desktop(css``)}
`;
